import { render, staticRenderFns } from "./ProductImageAvatar.vue?vue&type=template&id=334993c3&scoped=true&"
import script from "./ProductImageAvatar.vue?vue&type=script&lang=js&"
export * from "./ProductImageAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ProductImageAvatar.vue?vue&type=style&index=0&id=334993c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334993c3",
  null
  
)

export default component.exports